import { cn } from '@change/ds-utils';

export const CheckBox: React.FC = () => {
	return (
		<div
			className={cn(
				'relative mt-[2px] flex h-4 w-4 shrink-0 items-center justify-center rounded-full',
				'border-stroke-strong border border-1',
				'group-data-[focus-visible]:outline-stroke-selected group-data-[focus-visible]:outline group-data-[focus-visible]:outline-2 group-data-[focus-visible]:outline-offset-2',
				// Base background colors
				'bg-fill-inverse-strong',
				'group-data-[selected]:bg-fill-selected group-data-[selected]:border-transparent',
				// After pseudo-element for color mixing with transparency
				"after:absolute after:inset-0 after:content-['']",
				'group-hover:after:bg-fill-hover',
				'group-data-[pressed]:after:bg-fill-press',
				// Invalid and disabled states
				'group-data-[invalid]:border-stroke-error-strong',
				'group-data-[disabled]:border-stroke-disabled group-data-[disabled]:group-data-[selected]:bg-fill-disabled',
			)}
		>
			<svg
				className="group-selected:block hidden scale-75"
				width="14"
				height="14"
				viewBox="0 0 14 14"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					className="group-data-[disabled]:fill-icon-disabled fill-white"
					d="M5.13046 9.26041L2.69796 6.82791L1.86963 7.65041L5.13046 10.9112L12.1305 3.91124L11.308 3.08875L5.13046 9.26041Z"
				/>
			</svg>
		</div>
	);
};
